function sectionCard(title: string, items: string[], tone: "ready" | "review" | "blocked") {
  const toneStyles =
    tone === "ready"
      ? {
          border: "1px solid rgba(44, 93, 67, 0.14)",
          background:
            "linear-gradient(180deg, rgba(244, 250, 246, 0.96), rgba(255, 252, 248, 0.98))",
          eyebrowColor: "#214735",
        }
      : tone === "blocked"
        ? {
            border: "1px solid rgba(162, 62, 62, 0.16)",
            background:
              "linear-gradient(180deg, rgba(255, 245, 243, 0.96), rgba(255, 252, 248, 0.98))",
            eyebrowColor: "#812d2d",
          }
        : {
            border: "1px solid rgba(181, 141, 34, 0.16)",
            background:
              "linear-gradient(180deg, rgba(255, 250, 239, 0.96), rgba(255, 252, 248, 0.98))",
            eyebrowColor: "#6d5210",
          };

  return (
    <section
      style={{
        borderRadius: 24,
        border: toneStyles.border,
        background: toneStyles.background,
        padding: "1rem",
        boxShadow: "0 18px 34px rgba(77, 61, 44, 0.06)",
      }}
    >
      <div
        style={{
          fontSize: "0.72rem",
          letterSpacing: "0.12em",
          textTransform: "uppercase",
          color: toneStyles.eyebrowColor,
          fontWeight: 700,
        }}
      >
        {title}
      </div>
      <ul
        style={{
          margin: "0.8rem 0 0",
          paddingLeft: "1.1rem",
          color: "#4d453d",
          lineHeight: 1.7,
        }}
      >
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </section>
  );
}

export default function StudioLaunchCandidateCloseout(props: {
  title: string;
  summary: string;
  scoreLabel: string;
  scoreValue: string;
  scoreDetail: string;
  proofSummary: string[];
  knownBlockers: string[];
  nextOperatorWorkflow: string[];
}) {
  return (
    <section
      style={{
        marginTop: "1rem",
        display: "grid",
        gap: "0.9rem",
      }}
    >
      <div
        style={{
          borderRadius: 26,
          border: "1px solid rgba(41, 84, 103, 0.14)",
          background:
            "linear-gradient(180deg, rgba(240, 248, 250, 0.92), rgba(248, 251, 252, 0.98))",
          padding: "1rem 1.05rem",
        }}
      >
        <div
          style={{
            fontSize: "0.74rem",
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            color: "#5b7884",
            fontWeight: 700,
          }}
        >
          Install-week closeout
        </div>
        <h2
          style={{
            margin: "0.42rem 0 0",
            fontSize: "1.16rem",
            color: "#26221d",
            fontWeight: 700,
          }}
        >
          {props.title}
        </h2>
        <p style={{ margin: "0.65rem 0 0", color: "#39535f", lineHeight: 1.7 }}>
          {props.summary}
        </p>

        <div
          style={{
            marginTop: "0.95rem",
            display: "grid",
            gridTemplateColumns: "minmax(180px, 220px) minmax(0, 1fr)",
            gap: "0.9rem",
            alignItems: "start",
          }}
        >
          <div
            style={{
              borderRadius: 22,
              border: "1px solid rgba(41, 84, 103, 0.14)",
              background: "rgba(255, 255, 255, 0.72)",
              padding: "0.95rem",
            }}
          >
            <div
              style={{
                fontSize: "0.72rem",
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                color: "#5b7884",
                fontWeight: 700,
              }}
            >
              {props.scoreLabel}
            </div>
            <div
              style={{
                marginTop: "0.38rem",
                fontSize: "1.5rem",
                lineHeight: 1,
                color: "#173847",
                fontWeight: 700,
              }}
            >
              {props.scoreValue}
            </div>
            <p style={{ margin: "0.55rem 0 0", color: "#4d453d", lineHeight: 1.6 }}>
              {props.scoreDetail}
            </p>
          </div>

          <div
            style={{
              borderRadius: 22,
              border: "1px solid rgba(54, 44, 35, 0.08)",
              background:
                "linear-gradient(180deg, rgba(251, 248, 243, 0.98), rgba(255, 255, 255, 0.98))",
              padding: "0.95rem",
            }}
          >
            <div
              style={{
                fontSize: "0.72rem",
                letterSpacing: "0.12em",
                textTransform: "uppercase",
                color: "#85796e",
                fontWeight: 700,
              }}
            >
              Release-quality handoff posture
            </div>
            <p style={{ margin: "0.55rem 0 0", color: "#4d453d", lineHeight: 1.7 }}>
              This closeout packages VetCan Studio as a premium install-week walkthrough
              surface: proof-backed for demos and operator handoff, blocker-honest in
              wording, and still clearly separated from public-live deployment.
            </p>
          </div>
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
          gap: "0.9rem",
        }}
      >
        {sectionCard("Proof summary", props.proofSummary, "ready")}
        {sectionCard("Known blockers", props.knownBlockers, "blocked")}
        {sectionCard("Next operator workflow", props.nextOperatorWorkflow, "review")}
      </div>
    </section>
  );
}
